<template>
	<div>
		<div class="header-annual-fee text-popper" v-textPopper v-if="showState">
			<span>
				{{ showTip }}
				<!-- <span class="href" @click="toRenew">{{ tip }}>>></span> -->
			</span>
			<i class="el-icon-close" @click="isShow = false" />
		</div>
		<!-- <OpenNewrenew ref="openNewRenew" /> -->
	</div>
</template>

<script lang='ts'>
import { computed, ref } from "@vue/composition-api"
import dayjs from "dayjs"
// import { openNewrenew } from '@/components/new_renew/new_renew'
// import OpenNewrenew from "@/components/new_renew/new_renew.vue"
import { openNewRenew } from '@/components/new_renew/new_renew.tsx'

export default {
    setup(props, ctx) {
        const isShow = ref(true)
        const tip = ref("")
        // 判断是试用期还是已购买
        const isTryOut = ctx.root.$store.state.shop.shopInfo.use_status
        console.log('isTryOut' + isTryOut )
        const shopInfo = computed(() => {
            return ctx.root.$store.state.shop.shopInfo
        })

        // const expired_time = ctx.root.$store.state.shop.shopInfo.expired_time
        // const today = dayjs(new Date().getTime()).format("YYYY-MM-DD")
        const remainDays = ctx.root.$store.state.shop.shopInfo.remain_days
        // if (expired_time) {
        //     remainDays =
        //         (new Date(expired_time).getTime() - new Date(today).getTime()) /
        //         (3600 * 24 * 1000)
        // }

        const showState = computed(() => {
            return remainDays <= 30 && isShow.value
        })

        const showTip = computed(() => {
            // 判断是否是试用期还是正式
            // let isTryOut = true;
            if (isTryOut === 1) {
                if (remainDays <= 30 && remainDays > 0) {
                    tip.value = "续费/升级"
                    return `${remainDays}天后到期，请及时续费/升级以免影响系统使用。`
                } else if (remainDays <= 0) {
                    return '店铺已到期，请及时续费/升级以免影响系统使用。'
                }
            } else if (isTryOut === 0) {
                if (remainDays <= 30 && remainDays > 0 ) {
                    tip.value = "开通正式版"
                    return `${remainDays}天后到期，请及时开通正式版以免影响系统使用。`
                } else if (remainDays <= 0) {
                    tip.value = "开通正式版"
                    return '店铺已到期，请及时开通正式版以免影响系统使用。'
                }
            }
        })
        return {
            isShow,
            showState,
            shopInfo,
            // toRenew,
            showTip,
            tip
        }
    },
    methods: {
        toRenew() {
            openNewRenew()
        }
    }
}
</script>

<style lang="scss" scoped>
.header-annual-fee {
	position: relative;
	flex-shrink: 0;
	height: 38px;
	line-height: 38px;
	background: #ffee83;
	color: #7c6045;
	font-weight: 500;
	font-size: 14px;
	text-align: center;
	z-index: 101;

	span {
		;
	}
}

.el-icon-close {
	position: absolute;
	right: 12px;
	top: 50%;
	transform: translateY(-50%);
	font-size: 24px;
	color: #333;
}
</style>
